import styled from 'styled-components';

export const ValidationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N900
      : props.theme.atlas.semantic.color.surface.inverse};
  flex-direction: column;
`;
